import React from 'react';

const MfaPlaceholder = props => {
  const { width = 500, height = 500, colors } = props;
  const { primary } = colors;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 200 200">
      <defs>
        <clipPath id="clip-MFA">
          <rect width="200" height="200" />
        </clipPath>
      </defs>
      <g id="MFA" clipPath="url(#clip-MFA)">
        <path
          id="Path_62278"
          data-name="Path 62278"
          d="M212.259,23.424,130.161.244a6.5,6.5,0,0,0-3.524,0l-82.1,23.181a5.827,5.827,0,0,0-4.37,5.528v85c0,11.055,4.755,22.372,14.133,33.636,7.163,8.6,17.072,17.242,29.453,25.676a268.986,268.986,0,0,0,42.139,23.224,6.479,6.479,0,0,0,5.011,0,268.993,268.993,0,0,0,42.139-23.224c12.38-8.435,22.289-17.073,29.452-25.676,9.378-11.264,14.133-22.581,14.133-33.636v-85A5.825,5.825,0,0,0,212.259,23.424Zm-7.894,90.524c0,19.565-20.858,37.91-38.355,49.855A263.841,263.841,0,0,1,128.4,184.84,263.838,263.838,0,0,1,90.788,163.8c-17.5-11.945-38.356-30.29-38.356-49.855v-80.7L128.4,11.8l75.966,21.449Z"
          transform="translate(-28.398 3.011)"
          fill="#020d88"
        />
        <path
          id="primary"
          d="M76.311,32.457H71.753v-8.38c0-11.565-10.21-20.951-22.79-20.951s-22.79,9.386-22.79,20.951v8.38H21.616c-5.014,0-9.116,3.771-9.116,8.38v41.9c0,4.609,4.1,8.38,9.116,8.38h54.7c5.014,0,9.116-3.771,9.116-8.38v-41.9C85.427,36.228,81.325,32.457,76.311,32.457Zm-13.218,0H34.834v-8.38c0-7.165,6.336-12.99,14.13-12.99s14.13,5.824,14.13,12.99Z"
          transform="translate(51.036 44.692)"
          fill={primary}
          opacity="0.4"
        />
      </g>
    </svg>
  );
};

export default MfaPlaceholder;
